var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullishArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1.313 10.5 L 5.25 6.563 L 7.762 9.074 C 8.488 7.643 9.686 6.506 11.153 5.856 L 12.752 5.144 M 12.752 5.144 L 9.287 3.813 M 12.752 5.143 L 11.422 8.609",
    fill: "transparent",
    stroke: "rgb(179, 179, 179)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullishArrow);
export default __webpack_public_path__ + "static/media/BullishArrow.9f8da39250b6f7ea69e8ae8ed7cedc15.svg";
export { ForwardRef as ReactComponent };